import { createSelector } from '@reduxjs/toolkit';
import { PayInMethodCode } from 'constants/pay-in-method';
import { stateName } from '../constants';

const checkoutState = state => state[stateName];

const localState = state => checkoutState(state).payment;

export const getFormState = state => localState(state).formState;
export const getCardAddAuth = state => localState(state).cardAddAuth;
export const getPayInMethods = state => localState(state).payInMethodsState.payInMethods;
export const getIsCardSingleUseOverriden = state => localState(state).isCardSingleUseOverriden;
export const getIsCardExpired = createSelector(getFormState, _ref => {
  let {
    errors
  } = _ref;
  return errors.isCardExpired;
});
export const getCardPayInMethod = createSelector(getPayInMethods, payInMethods => {
  return payInMethods.find(_ref2 => {
    let {
      code
    } = _ref2;
    return code === PayInMethodCode.CreditCard;
  });
});